"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.validate = exports.isSkipped = exports.initialValues = exports.icon = exports.getMetricsPrefix = exports.getMetrics = exports.getDataDefinitions = exports.getDataConnectorsValues = exports.getDataConnectors = exports.fields = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdSurveyCommon = require("cccisd-survey-common");
var _settings = require("../Player/settings.js");
var _difference_in_days = _interopRequireDefault(require("date-fns/difference_in_days"));
var _difference_in_years = _interopRequireDefault(require("date-fns/difference_in_years"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var fields = exports.fields = ['question', 'description', 'disallowPastDates', 'disallowFutureDates', 'isRequired', 'requiredErrorMessage', 'isRequiredExpanded'];
var initialValues = exports.initialValues = {
  question: '<p><strong>Please type or select a date</strong></p>',
  disallowPastDates: false,
  disallowFutureDates: false,
  requiredErrorMessage: 'An answer is required.',
  isRequiredExpanded: true
};
var icon = exports.icon = /*#__PURE__*/_react["default"].createElement("i", {
  className: "glyphicon glyphicon-calendar"
});
var validate = exports.validate = function validate(values) {
  return {};
};
var getMetricsPrefix = exports.getMetricsPrefix = function getMetricsPrefix() {
  return 'dt';
};
var getDataDefinitions = exports.getDataDefinitions = function getDataDefinitions(id, settings) {
  var prefix = getMetricsPrefix();
  return _defineProperty({}, id + '_answer', {
    title: (0, _cccisdSurveyCommon.stripTags)(settings.question),
    titleHtml: settings.question,
    type: 'string',
    questionType: 'date',
    reportHeader: "".concat(prefix, "_").concat(id),
    variableType: 'answer',
    tags: {
      system: ['answer']
    }
  });
};
var getMetrics = exports.getMetrics = function getMetrics(id, settings, answer) {
  var _processValue = (0, _settings.processValue)(answer),
    date = _processValue.date;
  if (!date) {
    return _defineProperty({}, id + '_answer', null);
  }
  return _defineProperty({}, id + '_answer', date);
};
var getDataConnectors = exports.getDataConnectors = function getDataConnectors(settings) {
  return {
    timeDurationYears: {
      type: 'number',
      title: 'Time duration calculator in years'
    },
    timeDurationDays: {
      type: 'number',
      title: 'Time duration calculator in days'
    }
  };
};
var getDataConnectorsValues = exports.getDataConnectorsValues = function getDataConnectorsValues(settings, answer) {
  var _processValue2 = (0, _settings.processValue)(answer),
    date = _processValue2.date,
    startedAt = _processValue2.startedAt;
  return {
    timeDurationYears: function timeDurationYears() {
      if (!date || !startedAt) {
        return 0;
      }
      return (0, _difference_in_years["default"])(startedAt, date);
    },
    timeDurationDays: function timeDurationDays() {
      if (!date || !startedAt) {
        return 0;
      }
      return (0, _difference_in_days["default"])(startedAt, date);
    }
  };
};
var isSkipped = exports.isSkipped = function isSkipped(_ref4) {
  var settings = _ref4.settings,
    answer = _ref4.answer;
  return !(answer !== null && answer !== void 0 && answer.date);
};